import { render } from "./EventDetails.vue?vue&type=template&id=60a1b2f2"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render

export default script